import React, { Component, Fragment, useState } from 'react';
import Select, { Option } from '../../../common/component/Select';
import Wrapper from '../../../common/component/Wrapper';
import useGetHotelisActive from './UseGetHotelisActive';

const RenderHotelisActive = ({
    onChangedHotel = () => { },
    defaultHotelId = 0,
    defaultOptionLabel = "Vui lòng chọn",
    isBeachVilla = false,
    isActive = true
}) => {
    const [hotelSearch, setHotelSearch] = useState(defaultHotelId)
    const [active] = useGetHotelisActive({ isBeachVilla: isBeachVilla, isActive: isActive })
    
    const onChangeSearchHotels = (e) => {
        onChangedHotel(e)
        setHotelSearch(e)
    }
    
    return (
        <Fragment>
            <Wrapper style={{ display: 'flex', marginRight: '20px' }}>
                <Select className={`form-control`}
                    value={hotelSearch}
                    onChange={(e) => onChangeSearchHotels(e.target.value)}
                    style={{ width: '100%' }}
                >
                    <Option key={0} value=''>{defaultOptionLabel}</Option>
                    {(active && Array.isArray(active)) ? active.map((hotel) => {
                        return hotel ? <Option key={hotel.id} value={hotel.id}>{hotel.name}</Option> : null;
                    }) : null}
                </Select>
            </Wrapper>
        </Fragment>
    )
}

export default RenderHotelisActive